import loadable from '@loadable/component';
import { ReactNode } from 'react';

import { Dropdown } from 'components/Dropdown/Dropdown';
import { postAListingRoute } from 'routing/routes';
import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

type Props = {
  locale: UserLocale;
  renderTrigger: (data: {
    triggerText: string;
    triggerHref: string;
  }) => ReactNode;
  trackClickedContext: string;
};

const triggerTextByLocale: Record<UserLocale, { text: string; href: string }> =
  {
    en: {
      text: 'Post on Idealist',
      href: postAListingRoute.with({}),
    },
    es: {
      text: 'Publica',
      href: postAListingRoute.with({}),
    },
    pt: {
      text: 'Anunciar',
      href: postAListingRoute.with({}),
    },
  };

const PostOnIdealistDropdownMenuLoadable = hydrateOnDemand(
  loadable(() => import('./PostOnIdealistDropdownMenu'), {
    resolveComponent: (module) => module.PostOnIdealistDropdownMenu,
  }),
);

export function PostOnIdealistDropdown({
  locale,
  renderTrigger,
  trackClickedContext,
}: Props) {
  const { text, href } = triggerTextByLocale[locale];

  return (
    <Dropdown
      trigger={renderTrigger({ triggerText: text, triggerHref: href })}
      desktopTriggersOnHover
    >
      <PostOnIdealistDropdownMenuLoadable
        locale={locale}
        trackClickedContext={trackClickedContext}
      />
    </Dropdown>
  );
}
